export const HOMEPAGE = '/management/properties';
